/**
 * Takes an OptionalClassNames object and filter false classNames.
 *
 * @param classNames OptionalClassNames object.
 */
export const filterClassNames = classNames =>
  classNames
    ? Object.keys(classNames).filter(className => classNames[className])
    : [];
export default filterClassNames;
